module.exports = __webpack_public_path__ + "media/icons/switch_white@2x-20d53f34.png";